// import Vue from 'vue'
import axios from 'axios'

const client = axios.create({
  baseURL: 'https://web-jienergi-svc-tst.azurewebsites.net/api/Report',
  json: true
})

export default {
  async execute(method, resource, data) {
    return client({
      method,
      url: resource,
      data,
      headers: {
      }
    }).then(req => {
      return req.data
    })
  },
  get(currentTime, period, serialNumber){
    var url = "Get?Moment=" + currentTime + "&Period=Hour&PeriodCount=" + period + "&MeterSerialNumber=" + serialNumber
    return this.execute('get', url)
  },
  getAll(para) {
    return this.execute('get', para)
  },
  create(data) {
    return this.execute('post', '/', data)
  },
  update(id, data) {
    return this.execute('put', `/${id}`, data)
  },
  delete(id) {
    return this.execute('delete', `/${id}`)
  }
}